import { Component, EventEmitter, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { BaseResponse } from 'app/models2/commos/base-response';
import { Data } from 'app/models2/commos/base-response-data';
import { GenericResponse } from 'app/models2/commos/generic-response';
import { UpdateData } from 'app/models2/commos/update-data';
import { Warehouse } from 'app/models2/inventory/warehouse';
import { DeleteGenericService } from 'app/services/delete-generic.service';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { HeaderFilters, HttpService, MenuBreadCrumb, MessageService, TableColumns, TableConfiguration, enumActions, enumRules, params } from 'brainloper-ui';

@Component({
  selector: 'app-warehouse',
  templateUrl: './warehouse.component.html',
  styleUrls: ['./warehouse.component.scss']
})
export class WarehouseComponent implements OnInit {


  public menuBreadCrumb: Array<MenuBreadCrumb> = [
    {
      name: "Inicio",
      router: '/inicio',
    },
    {
      name: "Bodegas Inventario",
      current: true
    }
  ]

  public urlTableW: string = `${EndpointDictionary.Warehouse.WAREHOUSE_TABLE}`;
  private urlCrudW: string = `${EndpointDictionary.Warehouse.CRUD_WAREHOUSE}`;
  private inactivateWarehouse: string = `${EndpointDictionary.Warehouse.INACTIVATE_WAREHOUSE}`;
  private activeWarehouse: string = `${EndpointDictionary.Warehouse.ACTIVE_WAREHOUSE}`;
  private urlUser: string = `${EndpointDictionary.User.USER_COMBO}`;

  public paramsWarehouse: params[] = [
    {
      id: 'active',
      value: 1
    }]


  public isChecked: boolean = true
  public labelToggle: string = "Bodegas activas"
  private numberOfWarehouse: number = 1

  public reloadTableW = new EventEmitter<any>();
  public configurationW: TableConfiguration = {
    edit: true,
    add: true,
    selectable: true,
    primaryKey: 'id',
    exportXslx: true,
    active:true
  };

  public columnsW: TableColumns<Warehouse>[] = [
    {
      ID: 'name',
      label: 'Nombre',
      type: 'text',
      style: {
        textAlign: 'center'
      },
    },
    {
      ID: 'responsible',
      label: 'Responsable',
      type: 'combo',
      style: {
        textAlign: 'center',
      },
      required: true,
      paramsCombo: {
        selectionField: 'userId',
        visibleField: 'name',
        url: this.urlUser,
      }
    },
    {
      ID: 'location',
      label: 'Ubicacion',
      type: 'text',
      style: {
        textAlign: 'center'
      },
    },
    {
      ID: 'description',
      label: 'Descripción',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil'
      },
    },
  ];

  headerFilters: Array<HeaderFilters> = [
    {
      tN: "bodegas",
      labelFilter:"Responsable",
      urlData: this.urlUser,
      visibleField:"name",
      primaryKey:"userId",
      type:"select",
      value:"",
      fileNameDb: "id_usuario"
    },
  ]

  headerFileXlsm: Array<params> = [
    { id: "responsible", value: "Responsable" },
    { id: "user", value: "Usuario" },
    { id: "name", value: "Nombre" },
    { id: "location", value: "Ubicación" },
    { id: "description", value: "Descripción" },
  ]

  constructor(
    public dialog: MatDialog,
    private message: MessageService,
    private http: HttpService,
    private deleteService: DeleteGenericService
  ) {
   }

  ngOnInit(): void {
  }

  dataFromTable($event:Data<Warehouse[]>){
    this.numberOfWarehouse = $event.data.length
    if(this.numberOfWarehouse === 1 && this.isChecked) {
      this.configurationW.active = false
    }else{
      this.configurationW.active = true
    }
  }

  async addW($event: Warehouse) {
    let form: Warehouse = {
      name: $event.name,
      description: $event.description,
      userId: $event.responsible,
      location: $event.location
    }
    await this.handlerData(this.urlCrudW, form, "post")
    this.reloadTableW.emit()
  }

  async editW($event: UpdateData<Warehouse>) {
    let form: Warehouse = {
      id: $event.old.id,
      name: $event.new.name,
      description: $event.new.description,
      userId: $event.new.responsible,
      location: $event.new.location,
      typeId: $event.old.typeId
    }
    await this.handlerData(this.urlCrudW, form, "put")
    this.reloadTableW.emit()
  }

  async handlerData(url: string, body, action: string) {
    let res: BaseResponse<GenericResponse>
    if (action == "post") {
      this.message.openLoading('Cargando', 'Creando dato')
    } else if (action == "put") {
      this.message.openLoading('Cargando', 'Actualizando dato')
    }

    try {
      if (action == "post") {
        res = await this.http.postDataPromise(url, body)
      } else if (action == "put") {
        res = await this.http.putDataPromise(url, body)
      }

      if (res['code'] === 0) {
        this.message.SuccessToast(res['message'])
        this.message.closeLoading()
      } else {
        this.message.closeLoading()
        this.message.Error('Error!', `Código: ${res['code']} - Mensaje : ${res['message']}`)
      }
    } catch (error) {
      this.message.Error('Error!', error.message)
      this.message.closeLoading()
    }
  }

  async inactivateOrActiveWarehouses($event: Warehouse[], active: boolean) {
    if(this.numberOfWarehouse === $event.length && this.isChecked){
      this.message.Warning('Advertencia', 'No puedes inactivar todas las bodegas activas')
      return
    }
    await this.deleteService.inactivateOrActivate($event, active, this.activeWarehouse, this.inactivateWarehouse, 'Bodega')
    this.reloadTableW.emit()
  }


  changeToggle($event: MatSlideToggleChange) {
    if ($event.checked) {
      this.labelToggle = "Bodegas Activas"
      this.paramsWarehouse[0].value = 1
    } else {
      this.labelToggle = "Bodegas Inactivas"
      this.paramsWarehouse[0].value = 0
    }
    this.reloadTableW.emit()
  }

}
